export default __webpack_public_path__ + "static/media/ap1.c3e8fa4e.png";